import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import Header from "../components-layout/Header";
import Cookies from "universal-cookie";
import Container from "../components-layout/Container";
import Layout from "../Layout";
import WarningModal from "../components-modals/WarningModal";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  EyeIcon,
  BanknotesIcon,
} from "@heroicons/react/24/outline";
import {
  handlePedidos,
  handleIdProdProv,
  handleNumEnvio,
  handleChecked,
  handleFecha,
  handleSubmit,
  handleKeyDown,
  handleFechaActual,
} from "./utilities/handlers";
import SearchForm from "../components-contabilidad-analisis/SearchForm";
import { FileExportLogo } from "../components-layout/Logos";
import usePedidos from "./hooks/usePedidos";
import { getCurrentDate } from "./utilities/Index";
import CardPedido2 from "./components/CardPedido2";
import GridPedido3 from "./components/GridPedido3";
import Stats from "./components/Stats";
import {
  TruckIcon,
  InboxArrowDownIcon,
  ClipboardDocumentCheckIcon,
  ListBulletIcon,
} from "@heroicons/react/24/outline";
import { useRevisionFacturas } from "./hooks/useRevisionFacturas";
import CardRevisados from "./components/CardRevisados";
import GridPedidos from "../pago-envios-proveedores/components/GridPedidos";
import { aFechaConDiagonales } from "../tools/ConversionFechas";
import { enviar } from "../pago-envios-proveedores/services/envios.services";

const ProveedoresIndex = () => {
  const [entregadosStat, setEntregadosStat] = useState([]);
  const [revisadosStat, setRevisadosStat] = useState([]);
  const [pagadosStat, setPagadosStat] = useState([]);
  const [parcialStat, setParcialStat] = useState([]);
  const [pedidosStat, setPedidosStat] = useState([]);
  const [idsSeleccionados, setIdsSeleccionados] = useState([]);
  const [showDatosFactura, setShowDatosFactura] = useState(false);
  const [showDataFactura, setShowDataFactura] = useState(false);
  const [objSeleccionados, setObjSeleccionados] = useState([]);
  //const searchParams = ['Bodega', 'IdEnvio']
  const [datosFactura, setDatosFactura] = useState({
    fechaFactura: "",
    fechavence: "",
    factura: "",
  });
  // FechaVence": "20240915"
  const [dataFactura, setDataFactura] = useState({
    Factura: "",
    FechaFactura: "",
    FechaVence: "",
  });

  const menosRef = useRef();
  const cookies = new Cookies();
  const idProveedor = cookies.get("IdProveedor");
  const [proveedor, setProveedor] = useState(idProveedor);
  const [coleccion, setColeccion] = useState([]);
  const [stats, setStats] = useState([]);
  const [option, setOption] = useState(4);
  //const urlInvoiceApi = cookies.get('__urlInvoiceApi')
  const urlState2 = useSelector((state) => state.url.urlInvoiceApi);
  const urlInvoiceApi =
    urlState2 === "" || urlState2 === undefined || urlState2 === null
      ? cookies.get("__urlInvoiceApi")
      : urlState2;
  /*
    GET /invoiceapi/utils/busquedas
    {
      "opcion": "REVISIONFACTURAS"
    }
    */
  const [facturas] = useRevisionFacturas([], urlInvoiceApi);
  const [pedidosResponse] = usePedidos([], urlInvoiceApi);
  const [pedidos, setPedidos] = useState([]);
  const [fechaActual, setFechaActual] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [numEnvio, setNumEnvio] = useState("");
  const [recepcion] = useState(false);
  const [historyPedidos, setHistoryPedidos] = useState([]);
  //Datos y estados para layout y fetch inicial
  const { user, IdEmp } = useSelector((state) => state.auth);
  const userObj = JSON.parse(user);

  const headers = useSelector((state) => state.url.headersAPI);
  const [contador, setContador] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showIcon, setShowIcon] = useState(true);
  const esProveedor = true;
  //Fetch inicial
  const [rawData, setRawData] = useState([]);
  const [menuCredito, setMenuCredito] = useState(false);
  //Busqueda
  const [filterData, setFilter] = useState([]);
  const recordsPerPage = 500;

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords =
    filterData && filterData?.slice(indexOfFirstRecord, indexOfLastRecord);
  const nPages = Math.ceil(filterData?.length / recordsPerPage);
  const [pedidoSeleccionado, setPedidoSeleccionado] = useState();
  //Fin paginación Productos
  const campoPrincipal = "IdPedido";
  const columnas = [
    { fieldName: "IdPedido", active: true },
    { fieldName: "Bodega", active: true },
    { fieldName: "Proveedor", active: true },
    { fieldName: "Entregado", active: true },
    { fieldName: "Entrega Parcial", active: true },
    { fieldName: "Pedido", active: true },
  ];

  const columnasIconos = [
    { fieldName: "CantidadPedido", active: true },
    { fieldName: "CantidadEntregada", active: true },
    { fieldName: "Saldo", active: true },
    { fieldName: "CantidadSaldo", active: true },
  ];

  const inputLabels = [{ fieldName: "Unidades a enviar", active: true }];

  const iconosLabels = [
    { fieldName: "Unidades solicitadas", active: true },
    { fieldName: "Unidades entregadas", active: true },
    { fieldName: "Unidades pendientes de entregar", active: true },
  ];

  //Manejo de errores
  const [modal, setModal] = useState({
    show: false,
    msg: "",
    ok: false,
  });

  const [productosPedido, setProductosPedido] = useState([]);
  const [tituloBoton, setTituloBoton] = useState("Ver detalle");
  const [verDetalle, setVerDetalle] = useState(false);

  const handleVerMas = (e, dataParam, id, envio = false) => {
    setTituloBoton("");
    let filterDataCopy = dataParam;
    let filtrado = {};
    if (envio) {
      filtrado = filterDataCopy.find((f) => f["IdEnvio"] === id);
    } else {
      filtrado = filterDataCopy.find((f) => f[campoPrincipal] === id);
    }
    // if (!filtrado) {
    // }
    setProductosPedido(filtrado.Productos);
    //setProductosPedido(filtrado)
    setPedidoSeleccionado(filtrado);
    setVerDetalle(true);
  };

  const handleDataFactura = (e) => {
    setDataFactura({
      ...dataFactura,
      [e.target.name]: e.target.value,
    });
  };
  const handleModal = () => {
    // si existen los 2 datosm se procede a enviar la data
    if (
      dataFactura.Factura &&
      dataFactura.FechaFactura &&
      dataFactura.FechaVence
    ) {
      handleSubmit(
        setModal,
        pedidos,
        IdEmp,
        headers,
        dataFactura,
        setShowDataFactura,
      );
    } else {
      setShowDataFactura(() => false);
      setModal({
        show: true,
        ok: false,
        msg: "Ingrese los datos solicitados",
      });
    }
  };
  const formatearEnvios = () => {
    let envios = [];
    idsSeleccionados.map((e) =>
      envios.push({
        IdEnvio: e,
        Factura: datosFactura["factura"],
        FechaFactura: aFechaConDiagonales(datosFactura["fechaFactura"]),
        FechaVence: aFechaConDiagonales(datosFactura["fechavence"]),
        IdEmp: IdEmp,
      }),
    );
    return envios;
  };

  const sendFacturas = async () => {
    if (window.navigator.onLine) {
      let envios = formatearEnvios();
      let resultado = await enviar(envios, headers, urlInvoiceApi);
      if (resultado.every((e) => e === "0")) {
        // '0' es el valor actual de la respuesta desde la API
        setModal({
          show: true,
          ok: true,
          msg: "Transacción realizada con éxito",
          reload: true,
        });
      } else {
        setModal({
          show: true,
          ok: false,
          msg: "No se pudo completar la operación",
          reload: false,
        });
      }
    } else {
      setModal({
        show: true,
        ok: false,
        msg: "Verifique su conexión a internet",
        reload: true,
      });
    }
  };

  const handleIncDec = (
    e,
    pedidos,
    seleccionado,
    campoPrincipal,
    Idx,
    propiedadProducto,
    otraPropiedad,
    menosRef,
  ) => {
    let copiaPedidos = structuredClone(Object.values(pedidos).flat(Infinity));
    let pedido = copiaPedidos.find(
      (item) => item[campoPrincipal] === seleccionado[campoPrincipal],
    );

    if (e.target.name === "sumar") {
      if (
        pedido.Productos[Idx][otraPropiedad] <
        seleccionado.Productos[Idx][otraPropiedad]
      ) {
        pedido.Productos[Idx][otraPropiedad] =
          pedido.Productos[Idx][otraPropiedad] + 1;
        menosRef.current.value = parseInt(menosRef.current.value) + 1;
      }
      if (pedido.Productos[Idx][otraPropiedad] > 0) {
        pedido.Productos[Idx]["selected"] = true;
      }
    }
    if (e.target.name === "restar") {
      if (pedido.Productos[Idx][otraPropiedad] > 0) {
        pedido.Productos[Idx][otraPropiedad] =
          pedido.Productos[Idx][otraPropiedad] - 1;
        menosRef.current.value = parseInt(menosRef.current.value) - 1;
      }
      if (pedido.Productos[Idx][otraPropiedad] === 0) {
        pedido.Productos[Idx]["selected"] = false;
      }
    }
    setPedidos(() => copiaPedidos);
  };

  const searchParams = ["Producto", "Bodega", "IdPedido", "IdEnvio"];
  const doSearch = (query) => {
    if (query === "") {
      if (option === 4) {
        setPedidos(historyPedidos);
      } else {
        if (option === 1) {
          setPedidos([entregadosStat]);
        }
        if (option === 2) {
          setPedidos([parcialStat]);
        }
        if (option === 3) {
          setPedidos([pedidosStat]);
        }
        if (option === 5) {
          setPedidos([revisadosStat]);
        }
        if (option === 6) {
          setPedidos([pagadosStat]);
        }
      }
    } else {
      const filtro = Object.values(pedidos)
        .flat(Infinity)
        .filter((x) => {
          return searchParams.some((y) => {
            return (
              x[y]?.toString().toLowerCase().indexOf(query.toLowerCase()) > -1
            );
          });
        });
      if (option === 4) {
        setPedidos([filtro]);
      } else {
        setFilter(filtro);
      }
    }
  };

  const handlePedidoCheck = (
    e,
    index,
    pedidos,
    setPedidos,
    numEnvio,
    fechaActual,
    seleccionado,
    campoPrincipal,
  ) => {
    let copiaPedidos = structuredClone(pedidos);
    let found = copiaPedidos.find(
      (f) => f["IdEnvio"] === seleccionado["IdEnvio"],
    );

    if (e.target.checked) {
      // agregar
      let idFound = idsSeleccionados.find(
        (id) => id === seleccionado["IdEnvio"],
      );
      if (!idFound) {
        setIdsSeleccionados(() => [...idsSeleccionados, found["IdEnvio"]]);
        setObjSeleccionados(() => [...objSeleccionados, found]);
      }
    } else {
      const index = idsSeleccionados.indexOf(found["IdEnvio"]);
      if (index > -1) {
        // eliminar
        const copiaSeleccionados = structuredClone(idsSeleccionados);
        const copiaObjSeleccionados = structuredClone(objSeleccionados);
        copiaSeleccionados.splice(index, 1);
        copiaObjSeleccionados.splice(index, 1);
        setIdsSeleccionados(() => copiaSeleccionados);
        setObjSeleccionados(() => copiaObjSeleccionados);
      }
    }
  };

  const rellenar = () => {
    let pedidosCopia = Object.values(pedidos).flat(Infinity);
    let found = pedidosCopia.find(
      (e) => e[campoPrincipal] === pedidoSeleccionado[campoPrincipal],
    );
    found.Productos.forEach((e) =>
      e.CantidadSaldo ? (e.selected = true) : null,
    );
    setPedidos(pedidosCopia);
  };

  useEffect(() => {
    setFechaActual(() => getCurrentDate());
  }, []);

  useEffect(() => {
    setFilter(rawData);
  }, [rawData]);

  const handleQuery = (values) => {
    doSearch(values.query.trim());
    setCurrentPage(1);
  };
  useEffect(() => {
    if (option !== 4) {
      setPedidos([filterData]); // funciona pero hay que hacer que se setee a pedidos
    }
  }, [filterData]);

  useEffect(() => {
    if (contador === 1) {
      rellenar();
    }
  }, [contador]);

  useEffect(() => {
    if (!numEnvio) {
      setContador(() => 0);
    } else {
      setContador(() => contador + 1);
    }
  }, [numEnvio]);

  useEffect(() => {
    let todos = pedidosResponse.concat(facturas);
    let ordenados = todos.sort((a, b) => b.IdPedido - a.IdPedido);
    let groupBy = function (xs, keyParam) {
      let objeto = {};
      ordenados.forEach((e) => {
        e.mes = e[keyParam].split(" ")[0];
        objeto[e.mes] = [];
      });
      Object.keys(objeto).forEach((e, index) => {
        ordenados.forEach((f, i) => {
          if (e === f.mes) {
            objeto[e].push(ordenados[i]);
          }
        });
      });
      return objeto;
    };

    setPedidos(() => groupBy(ordenados, "FechaIngreso"));
    setHistoryPedidos(groupBy(ordenados, "FechaIngreso"));
    setColeccion(Object.values(ordenados).flat(Infinity));
    let datos = Object.values(ordenados).flat(Infinity);
    getData(datos);
    // let copiaPedidos = structuredClone(Object.values(pedidos).flat(Infinity));

    // aqui se puede poner el codigo que los agrupe
  }, [pedidosResponse]);

  useEffect(() => {
    function handleScroll(event) {
      if (document.activeElement.type === "number") {
        event.target.blur();
      }
    }
    window.addEventListener("wheel", handleScroll);
    window.addEventListener("keypress", handleKeyDown);
    return () => {
      window.removeEventListener("wheel", handleScroll);
      window.removeEventListener("keypress", handleKeyDown);
    };
  }, []);

  const seleccionarPedidos = (id) => {
    //
    setFilter(() => []);
    setOption(id);
    if (id === 1) {
      //setPedidos([])
      setFilter(() => entregadosStat);
    }
    if (id === 2) {
      //setPedidos([])
      setFilter(() => parcialStat);
    }
    if (id === 3) {
      //setPedidos([])
      setFilter(() => pedidosStat);
    }
    if (id === 4) {
      setPedidos(() => historyPedidos);
    }
    if (id === 5) {
      setPedidos(() => []);
      setFilter(() => revisadosStat);
    }
    if (id === 6) {
      //setPedidos([])
      setFilter(() => pagadosStat);
    }
  };

  const handleFacturaData = (e) => {
    setDatosFactura({
      ...datosFactura,
      [e.target.name]: e.target.value,
    });
  };

  const getData = (dataParam) => {
    setEntregadosStat(() => dataParam.filter((e) => e.Estatus === "Entregado"));
    setParcialStat(() =>
      dataParam.filter((e) => e.Estatus === "Entrega Parcial"),
    );
    setPedidosStat(() =>
      dataParam.filter((e) => ["Pedido", "Despachado"].includes(e.Estatus)),
    );
    setRevisadosStat(() => facturas.filter((e) => e.Estatus === "Revisado"));
    setPagadosStat(() => facturas.filter((e) => e.Estatus === "Pagado"));

    setStats(() => [
      {
        id: 3,
        name: "Pendientes y despachados",
        stat: dataParam.filter((e) =>
          ["Pedido", "Despachado"].includes(e.Estatus),
        )["length"],
        icon: InboxArrowDownIcon,
        change: "3.2%",
        changeType: "decrease",
        Estatus: "Pedido",
      },
      {
        id: 2,
        name: "Pendientes de completar",
        stat: dataParam.filter((e) => e.Estatus === "Entrega Parcial")[
          "length"
        ],
        icon: ClipboardDocumentCheckIcon,
        change: "5.4%",
        changeType: "increase",
        Estatus: "Entrega Parcial",
      },
      {
        id: 1,
        name: "Entregados",
        stat: dataParam.filter((e) => e.Estatus === "Entregado")["length"],
        icon: TruckIcon,
        change: "122",
        changeType: "increase",
        Estatus: "Entregado",
      },
      {
        id: 5,
        name: "Revisados",
        stat: facturas.filter((e) => e.Estatus === "Revisado")["length"],
        icon: EyeIcon,
        change: "122",
        changeType: "increase",
        Estatus: "Revisado",
      },
      {
        id: 6,
        name: "Facturados",
        stat: facturas.filter((e) => e.Estatus === "Pagado")["length"],
        icon: BanknotesIcon,
        change: "122",
        changeType: "increase",
        Estatus: "Revisado",
      },
      {
        id: 4,
        name: "Todos",
        stat: dataParam["length"],
        icon: ListBulletIcon,
        change: "3.2%",
        changeType: "decrease",
        Estatus: "Todos",
      },
    ]);
  };
  const handleShowDatosFactura = () => {
    setShowDatosFactura(true);
  };

  const handleBlur = (id, seleccionado) => {
    let copiaPedidos = structuredClone(Object.values(pedidos).flat(Infinity));
    let pedido = copiaPedidos.filter(
      (item) => item[campoPrincipal] === seleccionado[campoPrincipal],
    );
    try {
      pedido.Productos[id]["Saldo"] = seleccionado.Productos[id]["Saldo"];
    } catch (error) {}
    try {
      pedido.Productos[id]["CantidadSaldo"] =
        seleccionado.Productos[id]["CantidadSaldo"];
    } catch (error) {}
    setPedidos(() => copiaPedidos);
  };
  return (
    <Layout userObj={userObj} activeTab="Proveedores">
      <WarningModal
        open={loading ? true : false}
        image={<img src="./img/loader.gif" alt="loading" />}
        opacity="bg-opacity-100"
      />
      <WarningModal
        open={modal.show ? true : false}
        width={menuCredito ? "w-[40%]" : ""}
        image={
          modal.ok ? (
            <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
          ) : (
            <ExclamationCircleIcon
              className={showIcon ? "h-20 w-20 text-red-500 mx-auto" : "hidden"}
            />
          )
        }
        title="Aviso"
        subtitle={<span>{modal.msg}</span>}
        opacity="bg-opacity-50"
      >
        <div className="mt-5 sm:mt-6">
          <button
            onClick={() => {
              if (modal.reload) {
                window.location.reload();
              }
              setModal((curr) => ({
                ...curr,
                show: false,
                reload: false,
              }));
            }}
            type="button"
            className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
          >
            Entendido
          </button>
        </div>
      </WarningModal>

      <Container height="h-full">
        <Header title="Proveedores" logo={FileExportLogo} />
        <div className="flex flex-col gap-5 justify-center mb-4">
          {!verDetalle ? (
            !showDatosFactura ? (
              <div className="flex flex-col xl:flex-row">
                <div className="flex w-[100%] justify-start flex-row">
                  <Stats
                    data={pedidos}
                    setPedidos={setPedidos}
                    setFilter={setFilter}
                    historyPedidos={historyPedidos}
                    seleccionarPedidos={seleccionarPedidos}
                    entregadosStat={entregadosStat}
                    parcialStat={parcialStat}
                    pedidosStat={pedidosStat}
                    stats={stats}
                    getData={getData}
                    option={option}
                    esProveedor={esProveedor}
                  />
                </div>
                <div className=" flex flex-col justify-end ">
                  <SearchForm
                    handleQuery={handleQuery}
                    placeholder="Buscar por #pedido o bodega"
                  />
                </div>
              </div>
            ) : null
          ) : null}
          <div
            className={
              showDatosFactura
                ? "flex flex-col md:flex-row gap-2 mx-auto justify-between"
                : "flex flex-col md:flex-row gap-2 justify-between"
            }
          >
            {!verDetalle ? (
              <div className="mb-2">
                {Object.values(pedidos).map((e, i) => {
                  return (
                    <>
                      {Object.keys(pedidos)[i] !== "0" ? (
                        <div className="my-4 bg-secundarioMira text-center py-2 rounded-md">
                          <p className="conmeses mx-auto text-white text-xl font-medium">
                            {Object.keys(pedidos)[i]}
                          </p>
                        </div>
                      ) : null}
                      {![5].includes(option) ? (
                        <CardPedido2
                          data={e}
                          pedidos={e}
                          setPedidos={setPedidos}
                          handleChecked={handleChecked}
                          fechaActual={fechaActual}
                          numEnvio={numEnvio}
                          columnas={columnas}
                          handleVerMas={handleVerMas}
                          campoPrincipal={campoPrincipal}
                          pedidoSeleccionado={pedidoSeleccionado}
                          columnasIconos={columnasIconos}
                          seleccionado={pedidoSeleccionado}
                          iconosLabels={iconosLabels}
                          recepcion={recepcion}
                          esProveedor={esProveedor}
                          //idsSeleccionados={filterData}
                        />
                      ) : (
                        <div>
                          {!showDatosFactura && [5].includes(option) ? (
                            <>
                              <p className="text-white mb-4">
                                Seleccione los envíos revisados para ingresar
                                los datos de la factura correspondiente
                              </p>
                              <CardRevisados
                                data={filterData}
                                pedidos={filterData}
                                setPedidos={setPedidos}
                                handleChecked={handleChecked}
                                fechaActual={fechaActual}
                                numEnvio={numEnvio}
                                columnas={columnas}
                                handleVerMas={handleVerMas}
                                campoPrincipal={campoPrincipal}
                                pedidoSeleccionado={pedidoSeleccionado}
                                columnasIconos={columnasIconos}
                                seleccionado={pedidoSeleccionado}
                                iconosLabels={iconosLabels}
                                recepcion={recepcion}
                                esProveedor={esProveedor}
                                handlePedidoCheck={handlePedidoCheck}
                                idsSeleccionados={idsSeleccionados}
                              />
                            </>
                          ) : (
                            <div className="flex flex-row ">
                              <GridPedidos
                                setShowDatosFactura={setShowDatosFactura}
                                pedidos={objSeleccionados}
                                handleFacturaData={handleFacturaData}
                                datosFactura={datosFactura}
                                sendFacturas={sendFacturas}
                              ></GridPedidos>
                            </div>
                          )}

                          {!verDetalle &&
                            idsSeleccionados.length > 0 &&
                            !showDatosFactura && (
                              <div className="flex flex-row justify-end p-2">
                                <button
                                  className="/w-full p-2 rounded-md px-auto py-auto text-center text-md text-gray-100 hover:bg-secundario bg-azulBrillanteMira flex flex-row justify-center transition duration-500 ease"
                                  onClick={() => handleShowDatosFactura()}
                                >
                                  Ingresar datos de facturas
                                </button>
                              </div>
                            )}
                        </div>
                      )}
                    </>
                  );
                })}
              </div>
            ) : (
              productosPedido?.length > 0 && (
                <div className="flex w-full justify-center gap-2 flex-col">
                  <GridPedido3
                    data={productosPedido}
                    pedidos={pedidos}
                    columnas={columnas}
                    campoPrincipal={campoPrincipal}
                    seleccionado={pedidoSeleccionado}
                    setPedidoSeleccionado={setPedidoSeleccionado}
                    fechaActual={fechaActual}
                    handleFechaActual={handleFechaActual}
                    setFechaActual={setFechaActual}
                    handleFecha={handleFecha}
                    setModal={setModal}
                    handlePedidos={handlePedidos}
                    handleIdProdProv={handleIdProdProv}
                    handleNumEnvio={handleNumEnvio}
                    handleChecked={handleChecked}
                    setPedidos={setPedidos}
                    setNumEnvio={setNumEnvio}
                    numEnvio={numEnvio}
                    columnasIconos={columnasIconos}
                    inputLabels={inputLabels}
                    iconosLabels={iconosLabels}
                    handleIncDec={handleIncDec}
                    esProveedor={esProveedor}
                    handleBlur={handleBlur}
                    menosRef={menosRef}
                  />
                  <div className="flex flex-row justify-between  lg:w-[100%] xl:w-[80%] xl:mx-auto">
                    <button
                      className="inline justify-end rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                      onClick={() => {
                        setVerDetalle(false);
                        seleccionarPedidos(4);
                        setPedidos(() => historyPedidos);
                      }}
                    >
                      Atrás
                    </button>
                    {numEnvio && pedidoSeleccionado.Estatus !== "Entregado" ? (
                      <button
                        className="inline justify-end rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                        onClick={() =>
                          handleSubmit(
                            setModal,
                            pedidos,
                            pedidoSeleccionado,
                            IdEmp,
                            headers,
                            urlInvoiceApi,
                            proveedor,
                            idProveedor,
                          )
                        }
                      >
                        Realizar envío
                      </button>
                    ) : null}
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </Container>
    </Layout>
  );
};

export default ProveedoresIndex;
